import script from "./bauDoTesouroView.vue?vue&type=script&setup=true&lang=ts"
export * from "./bauDoTesouroView.vue?vue&type=script&setup=true&lang=ts"

import "./bauDoTesouroView.vue?vue&type=style&index=0&id=5de3bd02&scoped=true&lang=css"

import exportComponent from "../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-5de3bd02"]])

export default __exports__